import designCollection from 'apps/designdetails/models/designCollection';
import design from 'apps/designdetails/models/design';
import designComment from 'apps/designdetails/models/designComment';
import designCommentCollection from '@99designs/ddo/models/designCommentCollection';

export default {
    designCollection,
    designComment,
    design,
    designCommentCollection,
};



// WEBPACK FOOTER //
// ./src/js/apps/designdetails/di.js